import React from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import Cart from "../cart/cart";

const CartScreen = () => {
    return <>
        <Header/>
        <Cart/>
        <Footer/>
    </>
}

export default CartScreen;
